import React, { useState, useEffect, useRef } from "react"
import PropTypes from "prop-types"
import css from "./AutoScrollCarousel.scss"
import ImageLoader from "@components/ImageLoader/ImageLoader"

function CarouselAutoScroll(props) {
    const [activeDot, setActiveDot] = useState(0)

    const wrapperDiv = useRef(null)

    const { infoArray, width, height } = props
    const noOfSlides = infoArray?.length

    const updateIndex = (newIndex) => {
        if (newIndex >= noOfSlides) {
            newIndex = 0
        } else if (newIndex < 0) {
            newIndex = 0
        }
        setActiveDot(newIndex)
    }

    useEffect(() => {
        const interval = setInterval(() => {
            updateIndex(activeDot + 1)
        }, props.speed)
        return () => {
            if (interval) {
                clearInterval(interval)
            }
        }
    }, [activeDot])

    return (
        <div className={css.paddingBoth8}>
            <div className={` flexColumn ${css.carousel} `} ref={wrapperDiv}>
                <div
                    className={css.inner}
                    style={{
                        transform: `translateX(${-activeDot * 100}%)`,
                    }}
                >
                    {infoArray?.map((item, index) => {
                        return (
                            <div key={index} className={css.carouselItem}>
                                <div className="marginBoth-8 flexColumn alignCenter justifyCenter" id={index}>
                                    <div>
                                        <ImageLoader
                                            width={width}
                                            height={height}
                                            src={item?.image?.src}
                                            alt={item?.image.alt_text || ""}
                                            className={` ${css.imageImg} `}
                                        />
                                    </div>

                                    <div className={`l3SemiBold ${css.titleWrapper} `}>{item?.title}</div>
                                    <div className={`${css.descWrapper} flex alignCenter  `}>
                                        {item?.description}
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
            {infoArray?.length > 1 && (
                <div className={` ${css.dotsContainer}`}>
                    <div className={`flex ${css.dotsScrollableContainer}`}>
                        {infoArray?.map((el, index) => {
                            return (
                                <span
                                    key={index}
                                    className={`${css.dot} ${index === activeDot ? css.activeDot : ""}`}
                                    onClick={() => setActiveDot(index)}
                                />
                            )
                        })}
                    </div>
                </div>
            )}
        </div>
    )
}

CarouselAutoScroll.propTypes = {
    infoArray: PropTypes.arrayOf(
        PropTypes.shape({
            image: PropTypes.shape({
                src: PropTypes.string,
                alt_text: PropTypes.string,
            }),
            title: PropTypes.string,
            description: PropTypes.string,
        })
    ),

    speed: PropTypes.number,
    width: PropTypes.string,
    height: PropTypes.string,
}

CarouselAutoScroll.defaultProps = {
    speed: 5000,
}

export default CarouselAutoScroll
